module.exports = __webpack_public_path__ + "static/media/payee_hero.50484be3.png";